import { useParams } from "react-router-dom";
import WorkOnPractices from "./workOnPractices/WorkOnPractices";
import InProgressPractices from "./inProgressPractices/InProgressPractices";
import ToBeSigned from "./toBeSignedPractices/ToBeSignedPractices";
import WaitingPaymentPractices from "./waitingPaymentPractices/WaitingPaymentPractices";
import CommunicatedPractices from "./communicatedPractices/CommunicatedPractices";
import {StatusCodeE} from "../../model/models";

export default function PracticesPage() {
    const { id, status } = useParams<{ id: string; status: string }>(); // Ensure correct type

    const findPageByStatus = () => {
        if (status === StatusCodeE.DA_LAVORARE) {
            return <WorkOnPractices />;
        } else if (status === StatusCodeE.IN_LAVORAZIONE) {
            return <InProgressPractices />;
        } else if (status === StatusCodeE.DA_FIRMARE) {
            return <ToBeSigned />;
        }else if (status === StatusCodeE.NOTIFICA) {
            return <CommunicatedPractices />;
        }
        else if (status === StatusCodeE.ATTESA_PAGAMENTO) {
            return <WaitingPaymentPractices />;
        }
    };

    return <>{findPageByStatus()}</>;
}
